// Предопределенные теги для заказов

export const PREDEFINED_TAGS = [
  {
    id: 'work',
    name: 'Работа',
    color: '#3B82F6', // blue
    icon: '💼',
    description: 'Для рабочих задач'
  },
  {
    id: 'home',
    name: 'Дом',
    color: '#10B981', // green
    icon: '🏠',
    description: 'Домашнее использование'
  },
  {
    id: 'travel',
    name: 'Путешествия',
    color: '#F59E0B', // amber
    icon: '✈️',
    description: 'В путешествиях'
  },
  {
    id: 'backup',
    name: 'Резервный',
    color: '#EF4444', // red
    icon: '🔒',
    description: 'Резервная копия'
  },
  {
    id: 'family',
    name: 'Семья',
    color: '#8B5CF6', // purple
    icon: '👨‍👩‍👧‍👦',
    description: 'Для членов семьи'
  },
  {
    id: 'test',
    name: 'Тест',
    color: '#6B7280', // gray
    icon: '🧪',
    description: 'Для тестирования'
  },
  {
    id: 'streaming',
    name: 'Стриминг',
    color: '#EC4899', // pink
    icon: '🎬',
    description: 'Для видео и стриминга'
  },
  {
    id: 'gaming',
    name: 'Игры',
    color: '#14B8A6', // teal
    icon: '🎮',
    description: 'Для онлайн-игр'
  }
];

export const getTagById = (id) => {
  return PREDEFINED_TAGS.find(tag => tag.id === id);
};

export const getTagColor = (id) => {
  const tag = getTagById(id);
  return tag ? tag.color : '#6B7280';
};

export const getTagName = (id) => {
  const tag = getTagById(id);
  return tag ? tag.name : id;
};

export const getTagIcon = (id) => {
  const tag = getTagById(id);
  return tag ? tag.icon : '🏷️';
};











